<!--
 * @Author: your name
 * @Date: 2021-03-31 15:43:39
 * @LastEditTime: 2021-03-31 17:43:45
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: /xdap-h5/src/lib/ui/components/form/form-other-table-field/form-other-table-field.vue
-->
<template>
  <div class="form-other-table-field form-item">
    <x-proxy-form-item
      :showRequired="showRequired"
      :label="widget.label"
      :processTitle="widget.processTitle"
      :validatorRules="validatorRules"
      :validateKey="validateKey"
      :validateInfo="validateInfo"
      :disabled="true">
      <cube-input
        v-if="renderSence === 'edit'"
        v-model="formValue"
        :disabled="true"
        :placeholder="'请选择数据源'"
        :maxlength="widget.lengthLimit"
        :readonly="true"
        :tabindex="tabindex"
      ></cube-input>
      <input v-else-if="renderSence === 'read'" class="cube-input-field text-overflow" readonly :value="formValue || '-'" />
    </x-proxy-form-item>
  </div>
</template>

<script>
import FormWidgetConfigMixin from '../../../mixins/form-widget.mixin'
export default {
  name: 'FormOtherTableField',
  mixins: [FormWidgetConfigMixin],
  computed: {},
}
</script>
